// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__2fIN1","title":"Header_title__3na8O","img":"Header_img__n3j3Q","red":"Header_red__2Gf_N","icons":"Header_icons__2e9NV"};